import { useEffect } from "react";
import PaymentType from "./components/PaymentType";
import Payments from "./components/Payments/Payments";
import InputField from "./components/Inputs/InputField";
import DiscountReason from "./components/DiscountReason/DiscountReason";

const PaymentData = ({
  modalData,
  updateModalState,
  formik,
  setInputValue,
}) => {
  const paymentData = { ...modalData?.paymentData } || {};

  const addPaymentType = (item) => {
    paymentData.payment = item;

    updateModalState("paymentData", paymentData);
  };

  const addPayments = (key, value, index) => {
    // const paymentData = { ...modalData };
    // paymentData.payments[index] = {
    //   ...paymentData.payments[index],
    //   [key]: value,
    // };
    // updateModalState("groups", paymentData);
  };

  const addPaymentData = (key, value) => {
    paymentData[key] = value;

    updateModalState("paymentData", paymentData);
  };

  useEffect(() => {
    if (paymentData.amount && paymentData.paymentPart) {
      const amount = paymentData.amount;
      const discount = paymentData?.discount || 0;

      const totalAmount = amount - (amount * discount) / 100;
      const part = paymentData.paymentPart;
      const onePartPayment =
        (totalAmount - (paymentData.downPayment || 0)) / part;
      const paymentsDate = paymentData?.paymentStartDate
        ? new Date(paymentData.paymentStartDate)
        : "";

      const paymentArr = [];

      for (let i = 0; i < part; i++) {
        const currentDate = paymentsDate ? new Date(paymentsDate) : "";

        paymentArr.push({
          payment: onePartPayment.toFixed(2),
          paymentDate: currentDate,
          status: "wait",
        });

        if (paymentsDate) paymentsDate.setMonth(paymentsDate.getMonth() + 1);
      }

      paymentData.payments = paymentArr;
      paymentData.totalAmount = totalAmount;

      updateModalState("paymentData", paymentData);
    }
  }, [
    paymentData.discount,
    paymentData.amount,
    paymentData.paymentStartDate,
    paymentData.paymentPart,
    paymentData.downPayment,
  ]);

  return (
    <li className="group-li" style={{ listStyle: "none" }}>
      <div className="input-couples">
        <InputField
          inputName={"contractStartDate"}
          formik={formik}
          setInputValue={setInputValue}
          data={paymentData}
          addPaymentData={addPaymentData}
        />
        <InputField
          inputName={"contractEndDate"}
          formik={formik}
          setInputValue={setInputValue}
          data={paymentData}
          addPaymentData={addPaymentData}
        />
        <InputField
          inputName={"paymentStartDate"}
          formik={formik}
          setInputValue={setInputValue}
          data={paymentData}
          addPaymentData={addPaymentData}
        />
        <InputField
          inputName={"contractId"}
          formik={formik}
          setInputValue={setInputValue}
          data={paymentData}
          addPaymentData={addPaymentData}
        />
      </div>
      <PaymentType
        data={paymentData}
        modalData={modalData}
        addPaymentType={addPaymentType}
        formik={formik}
      />
      <div className="input-couples">
        <DiscountReason
          data={paymentData}
          addPaymentData={addPaymentData}
          formik={formik}
        />
        <InputField
          inputName={"discount"}
          formik={formik}
          setInputValue={setInputValue}
          data={paymentData}
          addPaymentData={addPaymentData}
        />
        <InputField
          inputName={"amount"}
          formik={formik}
          setInputValue={setInputValue}
          data={paymentData}
          addPaymentData={addPaymentData}
        />{" "}
        <InputField
          inputName={"paymentPart"}
          formik={formik}
          setInputValue={setInputValue}
          data={paymentData}
          addPaymentData={addPaymentData}
        />
        <InputField
          inputName={"totalAmount"}
          formik={formik}
          setInputValue={setInputValue}
          data={paymentData}
          addPaymentData={addPaymentData}
        />
        <InputField
          inputName={"downPayment"}
          formik={formik}
          setInputValue={setInputValue}
          data={paymentData}
          addPaymentData={addPaymentData}
        />
      </div>

      <h2 style={{ marginTop: "20px" }}>Ödənişlər</h2>
      {paymentData?.payments?.map((item, index) => (
        <Payments
          key={index}
          index={index}
          setInputValue={setInputValue}
          data={item}
          addPayments={addPayments}
          formik={formik}
        />
      ))}
    </li>
  );
};

export default PaymentData;
